export default class Html {
  public static getNode1 (info: string[]): string {
    const width = info.length > 3 ? info[3] : 0;
    return '<div class="p-2">' +
        '<div class="row">' +
          '<div class="col ps-3 treeview-title1 text-overflow pe-0">' + info[0] + ' </div>' +
          '<div style="width:' + width + 'px" class="treeview-info text-overflow ps-0">' + info[2] + '</div>' +
        '</div>' +
        '<div class="treeview-subtitle1 text-overflow">' + info[1] + '</div>' + 
      '</div>'
  }

  public static getNode2 (info: string[]): string {
    return '<div class="row my-0" > ' +
      '<div class="col-12 justify-center treeview-title2 text-overflow">' + '<div>' + info[0] + ' </div>' +
      '<div class="treeview-subtitle2 text-overflow">' + info[1] + '</div>' +
      '<div class="treeview-status text-overflow">' + info[2] + '</div>' +
      '</div>' +
      '</div>';
  }

  public static getNode3 (info: string[]): string {
    return '<div class="p-2">' +
        '<div class="row">' +
          '<div class="col ps-3 treeview-title1 text-overflow">' + info[0] + ' </div>' +
          '<div class="treeview-count">(' + info[1] + ')</div>' +
        '</div>' +
      '</div>'
  }

  public static getGroup (info: string): string {
    return '<div class="row py-5"> ' +
      '<div class="ps-1"> ' +
      '<div class="SectionPictoContact px-3"/>' + ' </div>' +
      '</div> ' +
      '<div class="col align-self-center treeview-section">' +
      '<div class="text-overflow">' + info + ' </div>' +
      '</div>' +
      '</div>';
  }

  public static getList (info: string[]): string {
   return '<div class="py-2 px-0"> ' +
     '<div class="treeview-title1 text-overflow">' + info[0] + ' </div>' +
     '<div class="treeview-subtitle1 text-overflow">' + info[1] + '</div>' +
     '</div>';
  }
}
